import styled from 'styled-components';

import ZoomInIcon from '../document-preview-icons/zoom-in-icon';
import ZoomOutIcon from '../document-preview-icons/zoom-out-icon';
import RotateLeftIcon from '../document-preview-icons/rotate-left-icon';
import RotateRightIcon from '../document-preview-icons/rotate-right-icon';
import SaveViewIcon from '../document-preview-icons/save-view-icon';

interface Props {
  color?: string;
}

function DocPreviewToolbar(props: Props) {
  return (
    <ToolbarPanel>
      <ToolbarContainer>
        <ToolbarAction>
          <ZoomInIcon color={props.color} />
        </ToolbarAction>

        <ToolbarAction>
          <ZoomOutIcon color={props.color} />
        </ToolbarAction>

        <ToolbarAction>
          <RotateLeftIcon color={props.color} />
        </ToolbarAction>

        <ToolbarAction>
          <RotateRightIcon color={props.color} />
        </ToolbarAction>

        <ToolbarAction>
          <SaveViewIcon color={props.color} />
        </ToolbarAction>
      </ToolbarContainer>
    </ToolbarPanel>
  );
}

const ToolbarPanel = styled.div`
  width: 100%;
  margin-top: 5px;
  padding-right: 75px;
  padding-left: 120px;
`;

const ToolbarContainer = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ToolbarAction = styled.li`
  padding: 10px;
  background: none;
  border: none;
  border-radius: 4px;
`;

export default DocPreviewToolbar;
